// eslint-disable-next-line @typescript-eslint/no-var-requires
const axios = require('axios')
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { setupCache, buildWebStorage } = require('axios-cache-interceptor')

const getBrowserLocalStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    try {
        return window.localStorage
    } catch {
        return null
    }
}

const cachedAxiosOptions = {
    methods: ['get'],
    headerInterpreter: () => {
        return 300
    },
    staleIfError: false,
}

const browserLocalStorage = getBrowserLocalStorage()
if (browserLocalStorage) {
    cachedAxiosOptions.storage = buildWebStorage(
        browserLocalStorage,
        'axios-cache:'
    )
}

const cachedAxios = setupCache(
    axios.create({
        baseURL:
            process.env && process.env.REACT_APP_KEDO_API_BASE_URL
                ? process.env.REACT_APP_KEDO_API_BASE_URL
                : '/api',
    }),
    cachedAxiosOptions
)

const emitRuntimeRecovery = (reason = 'auth-session-recovery') => {
    if (typeof window === 'undefined' || typeof CustomEvent === 'undefined') {
        return
    }
    window.dispatchEvent(
        new CustomEvent('kedo-runtime-recovery', {
            detail: { reason },
        })
    )
}

class Api {
    constructor() {
        this.base_url =
            process.env && process.env.REACT_APP_KEDO_API_BASE_URL
                ? process.env.REACT_APP_KEDO_API_BASE_URL
                : '/api'
        this.refreshTokenRequest = null
    }

    getTTLToken() {
        const response = axios.get(
            this.base_url.replace('/api', '') + '/ttl_token',
            { withCredentials: true }
        )
        return response
    }

    getContentListEndpoint(dossierId, displayId, mode, listId) {
        let url = `/dossier/${dossierId}/contentlist/${displayId}`
        if (mode === 'set') {
            return url + '/set'
        }

        return url + `/${mode}/${listId}`
    }

    getContentUserEndpoint(dossierId, displayId) {
        let url = `/dossier/${dossierId}/contentuser/${displayId}/set`
        return url
    }

    getBaseUrl() {
        return this.base_url
    }

    getGoogleConnect() {
        return this.base_url + '/connect/google'
    }

    getAzureConnect() {
        return this.base_url + '/connect/azure'
    }

    getPushNotificationEndpoint(id) {
        return '/pushsubscription' + (id ? '/' + id : '')
    }

    getSubscriptionPlanEndpoint() {
        return '/subscriptionplan'
    }

    getContextFilterEndpoint(id) {
        return '/contextfilter' + (id ? '/' + id : '')
    }

    getOwnSubscriptionEndpoint() {
        return '/subscription/own'
    }

    getOrderEndpoint() {
        return '/order'
    }

    getOwnContractEndpoint() {
        return '/contract/own'
    }

    getReactivateSubscriptionEndpoint(subId) {
        return '/subscription/own/' + subId + '/reactivate'
    }

    getDisplayCustomViewEndpoint(id) {
        return '/displaycustomview' + (id ? '/' + id : '')
    }

    getDisplayPositionCredentialsEndpoint() {
        return '/displayposition/credentials'
    }
    getIsCredentialAllowedEndpoint() {
        return '/credential_allowed'
    }

    getMyPageBlockEndpoint(id) {
        return '/mypageblock' + (id ? '/' + id : '')
    }

    getOwnActiveSubscriptionEndpoint() {
        return '/subscription/own/active'
    }

    getOwnContractUsageEndpoint() {
        return '/contract/own/usage'
    }

    getOwnContractCancelEndpoint() {
        return '/contract/own/cancel'
    }

    getMessageQueueEndpoint() {
        return '/messagequeue'
    }

    getOwnActiveContractEndpoint() {
        return '/contract/own/active'
    }

    getMailEndpoint() {
        return '/mail'
    }

    getRequestLogEndpoint() {
        return '/log'
    }

    getApplyTemplateEndpoint(templateId, state) {
        return '/template/apply/' + templateId + '/' + state
    }

    getKedocxEndpoint() {
        return '/kedocx'
    }

    getEnvironmentModuleEndpoint(id) {
        return '/environmentmodule' + (id ? '/' + id : '')
    }

    getModuleEndpoint() {
        return '/module'
    }

    getDossierQueryEndpoint(id) {
        return '/dossierquery' + (id ? '/' + id : '')
    }

    getCredentialEndpoint() {
        return '/credential'
    }

    getSubscriptionRestrictionEndpoint() {
        return '/subscriptionrestriction'
    }

    getDefDossierPermissionEndpoint(id) {
        if (id) {
            return '/defdossierpermission/' + id
        }
        return '/defdossierpermission'
    }

    getLocaleEndpoint() {
        return '/locale'
    }

    getContentDossierSubscriptionsEndpoint() {
        return '/dossier/subscriptions'
    }

    getContentDossierFavoriteEndpoint(dossierId) {
        if (!dossierId) {
            return '/dossier/favorite'
        }

        return '/dossier/' + dossierId + '/favorite'
    }

    getContentDossierSubscriptionEndpoint(dossierId, subscribe) {
        return (
            '/dossier/' +
            dossierId +
            '/' +
            (subscribe === true ? 'subscribe' : 'unsubscribe')
        )
    }

    getContentDossierEndpoint(id) {
        return '/dossier' + (id ? '/' + id : '')
    }

    getContentDossierLinkEndpoint() {
        return '/contentdossierlink'
    }

    getEventEndpoint(id) {
        return '/event' + (id ? '/' + id : '')
    }

    getMessageEndpoint() {
        return '/message'
    }

    getAdminTemplateTranslationEndpoint(id) {
        return '/admin/template/' + id + '/translation'
    }

    getAdminTemplateEndpoint() {
        return '/admin/template'
    }

    getUserTwoFactorEndpoint(userId) {
        return '/user/' + userId + '/twofactor'
    }

    getUserProfileEndpoint(identifier) {
        return '/user/' + identifier + '/profile'
    }

    getEnvironmentUserRoleEndpoint(userId, envId) {
        return '/user/' + userId + '/roles/' + envId
    }
    getUserEndpoint(userId) {
        return '/user' + (userId ? '/' + userId : '')
    }

    getToewijzingenConnectEndpoint(dossierId) {
        return '/module/ijwiwmo/toegewezenproduct/connect/' + dossierId
    }

    getToewijzingenEndpoint() {
        return '/module/ijwiwmo/toegewezenproducten'
    }

    getMassUpdateEndpoint() {
        return '/dossier/massupdate'
    }

    getFileEndpoint() {
        return '/file'
    }

    getRoleEndpoint(id) {
        return '/role' + (id ? '/' + id : '')
    }

    getImportEndpoint() {
        return '/import'
    }

    getImpersonateStartEndpoint() {
        return '/impersonation/start'
    }

    getImpersonateStopEndpoint() {
        return '/impersonation/stop'
    }

    getDataFieldEndpoint(id) {
        return '/defdossierdeffield' + (id ? '/' + id : '')
    }

    getDefDossierDefFieldEndpoint(id) {
        return this.getDataFieldEndpoint(id)
    }

    getUpdateBacklinkDefDossierLinkEndpoint() {
        return '/defdossierlink/backlink'
    }

    getDefDossierLinkEndpoint(id) {
        return '/defdossierlink' + (id ? '/' + id : '')
    }

    getDefFieldListEndpoint() {
        return '/deffieldlist'
    }

    getDefFieldEndpoint(id) {
        return '/deffield' + (id ? '/' + id : '')
    }

    getDisplayItemEndpoint(id) {
        return '/displayitem' + (id ? '/' + id : '')
    }

    getDisplayPositionEndpoint(id) {
        return '/displayposition' + (id ? '/' + id : '')
    }

    getDataStructureEndpoint(id) {
        return '/datastructure' + (id ? '/' + id : '')
    }

    getDossierLogEndpoint() {
        return '/dossierlog'
    }

    getDefDossierEndpoint(id) {
        return '/defdossier' + (id ? '/' + id : '')
    }

    getContractEndpoint() {
        return '/contract'
    }

    getEnvironmentLayoutEndpoint(id) {
        return '/environment/' + id + '/layout'
    }

    getEnvironmentEndpoint(id) {
        return '/environment' + (id ? '/' + id : '')
    }

    getSettingEndpoint(envId, settingId) {
        if (!envId) {
            throw new Error('Environment id is required')
        }
        return (
            '/environment/' +
            envId +
            '/setting' +
            (settingId ? '/' + settingId : '')
        )
    }

    getUserAvatarEndpoint(id, avatar, size) {
        if (size > 0 && size < 100) {
            return `/images/user/${id}_${avatar}_64.webp`
        }
        return `/images/user/${id}_${avatar}_200.webp`
    }

    getContractUserEndpoint() {
        return '/contractuser'
    }

    getEnvironmentUserEndpoint() {
        return '/environmentuser'
    }

    getEnvironmentLocaleEndpoint() {
        return '/environmentlocale'
    }

    getSecureShareEndpoint(id) {
        return '/dossier/' + id + '/secureshare'
    }

    getUserMeEndpoint() {
        return '/user/me/profile'
    }

    getWebhookEndpoint(id) {
        return '/webhook' + (id ? '/' + id : '')
    }

    /**
     * @param response
     * @returns {{generic: string}|{Object}}
     */
    getErrorFromApiCall(response) {
        if (
            response &&
            response.status === 400 &&
            response.data &&
            response.data.errors
        ) {
            return response.data.errors
        } else if (response && response.status === 403) {
            return { generic: '403_general_message' }
        }

        return { generic: 'Something went wrong' }
    }

    /**
     * @param {String} endpoint
     * @param {Object} options
     *
     * @returns {Promise<AxiosResponse<any>>}
     */
    getFull(endpoint, options, refreshToken = true) {
        this.getAndSetTokenStorageData()
        if (refreshToken === true) this.checkTokenForExpiryAndRenew()

        return this.__get(endpoint, options)
    }

    /**
     * @param {String} endpoint
     * @param {Object} options
     *
     * @returns {Promise<AxiosResponse<any>>}
     */
    getAsync = async (endpoint, options = {}, refreshToken = true) => {
        this.getAndSetTokenStorageData()
        if (refreshToken === true) this.checkTokenForExpiryAndRenew()

        options = this.applySecurityOptions(options)

        return await this.requestWithRuntimeRecovery(
            () => axios.get(this.base_url + endpoint, options),
            this.base_url + endpoint,
            options
        )
    }

    /**
     * @param {String} endpoint
     * @param {Object} options
     *
     * @returns {Promise<AxiosResponse<any>>}
     */
    getCached = async (endpoint, options = {}, refreshToken = true) => {
        this.getAndSetTokenStorageData()
        if (refreshToken === true) this.checkTokenForExpiryAndRenew()

        options = this.applySecurityOptions(options)

        return await this.requestWithRuntimeRecovery(
            () => cachedAxios.get(endpoint, options),
            endpoint,
            options
        )
    }

    /**
     * @param {String} endpoint
     * @param {Object} options
     *
     * @returns {Promise<AxiosResponse<any>>}
     */
    async get(endpoint, options, refreshToken = true) {
        this.getAndSetTokenStorageData()
        if (refreshToken === true) this.checkTokenForExpiryAndRenew()

        return await this.__get(this.base_url + endpoint, options)
    }

    /**
     * @param {String}  endpoint
     * @param {Object}  data
     * @param {Object}  options
     * @param {boolean} refreshToken
     * @returns {Promise<AxiosResponse<any>>}
     */
    async post(endpoint, data, options = {}, refreshToken = true) {
        this.getAndSetTokenStorageData()
        if (refreshToken === true) this.checkTokenForExpiryAndRenew()

        return await this.__post(this.base_url + endpoint, data, options)
    }

    /**
     * @param {String}  endpoint
     * @param {Object}  data
     * @param {Object}  options
     * @param {boolean} refreshToken
     * @returns {Promise<AxiosResponse<any>>}
     */
    put(endpoint, data, options, refreshToken = true) {
        this.getAndSetTokenStorageData()
        if (refreshToken === true) this.checkTokenForExpiryAndRenew()

        return this.__put(this.base_url + endpoint, data, options)
    }

    /**
     * @param {String}  endpoint
     * @param {Object}  options
     * @param {boolean} refreshToken
     * @returns {*}
     */
    delete(endpoint, options = {}, refreshToken = true) {
        this.getAndSetTokenStorageData()
        if (refreshToken === true) this.checkTokenForExpiryAndRenew()
        options = this.applySecurityOptions(options, true)

        return this.requestWithRuntimeRecovery(
            () => axios.delete(this.base_url + endpoint, options),
            this.base_url + endpoint,
            options
        )
    }

    /**
     * @param {Object}  endpoint
     * @param {Object}  data
     * @param {Object}  options
     * @param {boolean} refreshToken
     * @returns {Promise<AxiosResponse<any>>}
     */
    patch(endpoint, data, options = {}, refreshToken = true) {
        this.getAndSetTokenStorageData()
        if (refreshToken === true) this.checkTokenForExpiryAndRenew()

        return this.__patch(this.base_url + endpoint, data, options)
    }

    /**
     * @param {String}  endpoint
     * @param {Object}  data
     * @param {Object}  options
     * @returns {Promise<AxiosResponse<any>>}
     */
    postRaw(endpoint, data, options = {}) {
        endpoint = this.base_url + endpoint
        options = this.applySecurityOptions(options, true)
        return this.requestWithRuntimeRecovery(
            () => axios.post(endpoint, data, options),
            endpoint,
            options
        )
    }

    /**
     * Checks if we have a token else we need to login first
     * @returns {boolean}
     */
    hasToken() {
        this.getAndSetTokenStorageData()

        return this.tokenData != null
    }

    /**
     * Checks if a token is expired
     * @returns {boolean}
     */
    isTokenExpired() {
        if (!this.hasToken()) {
            return true
        }

        const now = new Date().getTime()
        const expirationTime = this.tokenData.exp * 1000
        const bufferTime = 5 * 60 * 1000

        return now >= expirationTime - bufferTime
    }

    applySecurityOptions(options = {}, forceWithCredentials = false) {
        // avoid mutating the original options object to prevent side effects
        const requestOptions = { ...(options || {}) }

        if (forceWithCredentials || requestOptions.disableSecurity !== true) {
            requestOptions.withCredentials = true
        }

        return requestOptions
    }

    getRuntimeRecoveryMessage(error) {
        const data = error?.response?.data
        const values = [
            error?.message,
            typeof data === 'string' ? data : null,
            data?.message,
            data?.detail,
            data?.error,
        ]

        return values.filter(Boolean).join(' ').toLowerCase()
    }

    isAuthRecoveryResponse(error) {
        const message = this.getRuntimeRecoveryMessage(error)

        return (
            message.includes('jwt token not found') ||
            message.includes('jwt token expired') ||
            message.includes('expired jwt token') ||
            message.includes('invalid jwt token') ||
            message.includes('session expired') ||
            message.includes('unauthenticated')
        )
    }

    shouldTriggerRuntimeRecovery(error, endpoint = '', options = {}) {
        if (
            options?.disableRuntimeRecovery === true ||
            options?.runtimeRecovery === false ||
            error?.__kedoRuntimeRecoveryHandled === true ||
            !error ||
            !error.response ||
            error.response.status !== 401
        ) {
            return false
        }

        if (this.shouldIgnoreRuntimeRecoveryEndpoint(endpoint)) {
            return false
        }

        return this.isAuthRecoveryResponse(error)
    }

    handleRuntimeRecoveryError(
        error,
        endpoint = '',
        options = {},
        rethrowUnhandled = true
    ) {
        if (this.shouldTriggerRuntimeRecovery(error, endpoint, options)) {
            emitRuntimeRecovery('auth-session-recovery')
            throw this.createHandledRecoveryError(error, endpoint)
        }

        if (rethrowUnhandled) {
            throw error
        }

        return undefined
    }

    requestWithRuntimeRecovery(
        request,
        endpoint = '',
        options = {},
        rethrowUnhandled = true
    ) {
        return request().catch((error) =>
            this.handleRuntimeRecoveryError(
                error,
                endpoint,
                options,
                rethrowUnhandled
            )
        )
    }

    shouldIgnoreRuntimeRecoveryEndpoint(endpoint) {
        const ignoredEndpoints = [
            '/login_check',
            '/key_login_check',
            '/refresh_token',
            '/logout_cookie',
            '/ttl_token',
            '/forgot_password',
            '/reset_password',
        ]

        return ignoredEndpoints.some((ignoredEndpoint) =>
            endpoint.includes(ignoredEndpoint)
        )
    }

    createHandledRecoveryError(error, endpoint = '') {
        if (!error || typeof error !== 'object') {
            return {
                __kedoRuntimeRecoveryHandled: true,
                endpoint,
                message: 'Runtime recovery handled',
            }
        }

        error.__kedoRuntimeRecoveryHandled = true
        error.__kedoRuntimeRecoveryEndpoint = endpoint
        return error
    }

    async __get(endpoint, options = {}) {
        options = this.applySecurityOptions(options)

        return await this.requestWithRuntimeRecovery(
            () => axios.get(endpoint, options),
            endpoint,
            options
        )
    }

    /**
     * @param endpoint
     * @param data
     * @param options
     * @returns {*}
     * @private
     */
    __patch(endpoint, data, options = {}) {
        options = this.applySecurityOptions(options, true)

        return this.requestWithRuntimeRecovery(
            () => axios.patch(endpoint, data, options),
            endpoint,
            options
        )
    }

    __put(endpoint, data, options = {}) {
        options = this.applySecurityOptions(options, true)

        return this.requestWithRuntimeRecovery(
            () => axios.put(endpoint, data, options),
            endpoint,
            options
        )
    }

    async __post(endpoint, data, options = {}) {
        options = this.applySecurityOptions(options, true)

        return await this.requestWithRuntimeRecovery(
            () => axios.post(endpoint, data, options),
            endpoint,
            options
        )
    }

    /**
     * Update token
     * @param {Object} tokenData Object from the jwt token response
     * @param {String} token
     * @param {String} refreshToken
     */
    updateToken(tokenData, token, refreshToken) {
        this.tokenData = tokenData
        this.token = token
        this.refreshToken = refreshToken

        //Store tokenData but don't store sensitive information
        const storage = getBrowserLocalStorage()
        storage?.setItem('tokenData', JSON.stringify(tokenData))
    }

    checkTokenForExpiryAndRenew() {
        //No token, do nothing
        if (true !== this.hasToken()) {
            return Promise.resolve()
        }

        if (this.refreshTokenRequest) {
            return this.refreshTokenRequest
        }

        // eslint-disable-next-line @typescript-eslint/no-extra-semi
        this.refreshTokenRequest = (async () => {
            if (false === (await this.tokenAlmostExpired())) {
                return
            }

            return this.__get(this.base_url + '/refresh_token')
                .then((response) => {
                    if (response.data.iat && response.data.exp) {
                        this.tokenData.exp = response.data.exp
                        this.tokenData.iat = response.data.iat
                        const storage = getBrowserLocalStorage()
                        storage?.setItem(
                            'tokenData',
                            JSON.stringify(this.tokenData)
                        )
                    }
                })
                .catch((error) => {
                    if (
                        error.response?.status &&
                        error.response.status === 401
                    ) {
                        this.tokenData = null
                        const storage = getBrowserLocalStorage()
                        storage?.removeItem('tokenData')
                    }
                })
        })().finally(() => {
            this.refreshTokenRequest = null
        })

        return this.refreshTokenRequest
    }

    /**
     * Check if token has a lifetime of equal or less then 5 minutes (in seconds)
     *
     * @returns {boolean}
     */
    async tokenAlmostExpired() {
        if (this.isTokenExpired() !== true) {
            return false
        }

        // If no local expiration time or the check failed, fallback to server-side check
        try {
            const response = await this.getTTLToken()
            const ttl = response.data.ttl
            return ttl <= 500
        } catch (error) {
            console.error('Error checking token TTL:', error)
            return false
        }
    }

    /**
     * Gets the storage tokendata from localstorage
     */
    getAndSetTokenStorageData() {
        //Token already set
        if (this.tokenData) {
            return
        }

        const storage = getBrowserLocalStorage()

        //No localstorage set
        if (!storage?.getItem('tokenData')) {
            return
        }

        try {
            this.tokenData = JSON.parse(storage.getItem('tokenData'))
        } catch {
            storage.removeItem('tokenData')
        }
    }
}

export default Api
